import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import AppointmentList from "../partials/list/AppointmentList";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function Appointments(props) {
    const { t } = useI18N();
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { variant: "h6", children: t('Toekomstige afspraken') }), _jsx(AppointmentList, { type: "future" }), _jsx(Typography, { variant: "h6", children: t('Afspraken in het verleden') }), _jsx(AppointmentList, { type: "past" })] }));
}
